import React, { useState, useEffect } from 'react'
import { useExchangeRates } from './hooks/useExchangerateApi';
// import CurrencyExchangeCombobox from './component/SendExchangeComponent';
import SendExchangeComponent from './component/SendExchangeComponent';
import ReceiveExchangeComponent from './component/ReceiveExchangeComponent';

export const roundToTwoDecimals = (value: any) => {
	return Number(value.toFixed(2));
};
const CurrencyConverter = () => {
	const [unit, setUnit] = useState(1)
	// sending
	const [sendingCurrency, setSendingCurrency] = useState({ code: "AUD", name: "Australian Dollar", flag: "https://flagcdn.com/40x30/au.webp", flagAlt: "Flag of AU" });
	const [sendAmount, setSendAmount] = useState(10);
	// receiving
	const [receivingCurrency, setReceivingCurrency] = useState({ code: "ZWL", name: "Zimbabwean Dollar", flag: "https://flagcdn.com/40x30/zw.webp", flagAlt: "Flag of ZW" });
	const [receiveAmount, setReceiveAmount] = useState(null);

	// send the send amount to hook to get received amount plus api data
	const { data, isLoading, isError, error, refetch } = useExchangeRates(sendingCurrency.code, receivingCurrency.code, unit);

	// if (data) {
	// 	console.log(sendingCurrency, receivingCurrency, "---")
	// }

	// useEffect(() => {
	// 	console.log(sendAmount, receiveAmount, "===")
	// }, [receiveAmount, sendAmount, receivingCurrency, sendingCurrency]);

	return (
		<div>
			{
				data && !isLoading ?
					<div className='cc-flex cc-flex-col cc-gap-4 not-prose cc-rounded-2xl'>
						<div className='cc-flex cc-flex-col cc-items-center cc-w-full cc-px-4 cc-py-6 cc-bg-primary-700 cc-rounded-xl cc-text-white'>
							<span>Exchange Rate</span>
							<div className='cc-flex cc-gap-3 cc-border-primary-900 cc-text-xl cc-font-bold'>
								<p>1{sendingCurrency.code === "ZWL" ? "USD" : sendingCurrency.code} = </p>
								<p>{(Math.floor((data.rates[receivingCurrency.code] || 0) * 100) / 100).toFixed(2)}{receivingCurrency.code === "ZWL" ? "USD" : receivingCurrency.code}</p>
							</div>
						</div>
						<SendExchangeComponent data={data} refetch={refetch} currency={sendingCurrency} setCurrency={setSendingCurrency} send={sendAmount} receive={receiveAmount} rate={data.rates[receivingCurrency.code]} setSend={setSendAmount} setReceive={setReceiveAmount} />
						<ReceiveExchangeComponent data={data} currency={receivingCurrency} setCurrency={setReceivingCurrency} send={sendAmount} receive={receiveAmount} rate={data.rates[receivingCurrency.code]} setSend={setSendAmount} setReceive={setReceiveAmount} />
						{/* {data && data.rates && (
						<div className="cc-exchange-rates cc-mt-6">
							<h3 className="cc-text-lg cc-font-medium cc-mb-2">Exchange Rates:</h3>
							<ul className="cc-space-y-1">
								{Object.entries(data.rates)
									.filter(([code]) => code !== sendingCurrency?.code)
									.map(([code, rate]) => (
										<li key={code} className="cc-text-sm">
											{sendAmount} {sendingCurrency?.code || sendingCurrency.code} = {(rate * sendAmount).toFixed(2)} {code}
										</li>
									))}
							</ul>
						</div>
					)} */}
					</div> :
					<div className='cc-flex cc-flex-col cc-items-center cc-gap-2 cc-h-16 cc-justify-center cc-bg-gray-50'>
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="cc-animate-spin cc-w-4 cc-h-4">
							<path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
						</svg>
					</div>

			}
		</div>
	)
}

export default CurrencyConverter
